import { Media } from 'graphql.generated';
import {
    EnergyPerfCertFragment,
    EnergyPerfCertExternal
} from './EnergyPerfCert.types';
import { LISTING_IMAGE_URL_PREFIX } from 'listing-details/constants';

export const mapFilesToExternal = (
    pdfs: Media[],
    images: Media[]
): EnergyPerfCertExternal[] => {
    const mappedPDFs = pdfs.map((item) => ({
        type: 'pdf',
        url: item.original,
        caption: item.caption
    }));

    const mappedImages = images.map((item) => ({
        type: 'image',
        url: `${LISTING_IMAGE_URL_PREFIX}1024/768/${item.filename}`,
        caption: item.caption
    }));

    return [...mappedPDFs, ...mappedImages] as EnergyPerfCertExternal[];
};

export const isImageNotPDF = (data: EnergyPerfCertFragment): boolean => {
    const { epc } = data;
    return Boolean(epc?.image && epc?.image.length > 0 && !epc?.pdf);
};

export const isPDF = (data: EnergyPerfCertFragment): boolean => {
    const { epc } = data;
    return Boolean(epc?.pdf && epc?.pdf.length > 0);
};
